import _ from 'lodash';

export function isDealAboveBnplMinimum(deal, settings) {
    const min_price = _.get(settings, 'bnpl_minimum_booking_amount', 0);
    if (!min_price || min_price <= 0) {
        return true;
    }
    return deal.totalPrice >= min_price;
}
